import * as React from "react";

function SvgPause(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -9 34 34" width={25.211} height={25.059} {...props}>
        <path
          d="M12 0a11.921 11.921 0 00-8.485 3.515A11.923 11.923 0 000 12a11.921 11.921 0 003.515 8.485A11.921 11.921 0 0012 24a11.923 11.923 0 008.486-3.514A11.921 11.921 0 0024 12a11.922 11.922 0 00-3.515-8.486A11.922 11.922 0 0012 0zm0 22.312a10.255 10.255 0 01-4.012-.812 10.334 10.334 0 01-3.279-2.21A10.265 10.265 0 012.5 16.015 10.236 10.236 0 011.688 12 10.263 10.263 0 012.5 7.987a10.354 10.354 0 012.21-3.279A10.265 10.265 0 017.985 2.5 10.236 10.236 0 0112 1.687a10.248 10.248 0 014.013.809 10.335 10.335 0 013.279 2.209 10.273 10.273 0 012.21 3.28A10.236 10.236 0 0122.313 12a10.24 10.24 0 01-.813 4.012 10.255 10.255 0 01-2.212 3.279 10.265 10.265 0 01-3.275 2.209 10.218 10.218 0 01-4.013.812zM15.633 7.5a.845.845 0 00-.844.843v7.312a.845.845 0 00.844.844.845.845 0 00.843-.844V8.343a.844.844 0 00-.843-.843zm-7.266 0a.845.845 0 00-.844.843v7.312a.845.845 0 00.844.844.845.845 0 00.843-.844V8.343a.844.844 0 00-.843-.843z"
          fill="#3c4252"
        />
      </svg>
    </span>
  );
}

export default SvgPause;
